export const WARDROBE_HISTORICAL_DATA_REQUEST =
  'user/WARDROBE_HISTORICAL_DATA_REQUEST';
export const WARDROBE_HISTORICAL_DATA_SUCCESS =
  'user/WARDROBE_HISTORICAL_DATA_SUCCESS';
export const WARDROBE_HISTORICAL_DATA_FAIL =
  'user/WARDROBE_HISTORICAL_DATA_FAIL';
